define('global/UI/SetupGlobals',[
	'jquery',
	'global/Logger',
	'./Helpers',
	'plugins/jquery.matchHeight',
	'plugins/jquery.matchHeights',
	'plugins/slick'
], function ($, Logger, Helpers) {
	'use strict';
	Logger.debug('Setting up Saf-T-Gard Global JS Plugins...');
	var other$ = jQuery;
	//-------------------------
	// True Globals
	//-------------------------
    /*
	 * Keydown event added to buttons for accessibility.
	 * Simply clicks the button to run that event.
	 */
	$("[role='button']").on("keydown", function (e) {
		if (e.keyCode === 13 || e.keyCode === 32) {
			$(this).click();
		}
	})

    /*
	 * "Scroll to top button handler"
	 * This button is in the footer.
	 */
	$("button.scroll-to-top").on("click touchend", function () {
		$('html,body').animate({
			scrollTop: 0
		}, 500);
		$("#main-content").focus();
	});

    /*
	 * IMPORTANT: This function finds img tags that have a [data-img-source] attribute 
     * the attr needs a valid json in this format to work. 
     * {
     *      "breakpoint": "original",
     *      "imgUrl": "/ResourcePackages/Roc/assets/images/client-images/banner-images/department-page-banner-static-image-sm-1.jpg" 
     *  },
     *  {
     *      "breakpoint": 550,
     *      "imgUrl": "/ResourcePackages/Roc/assets/images/client-images/banner-images/department-page-banner-static-image-lg-1.jpg" 
     *  } 
	 */
	var imgSrcHandler = Helpers.debounce(function () {
		var imgSrc = $("[data-img-source]").each(function () {
			var $this = $(this);
			var imgOptions = JSON.parse($(this).attr("data-img-source"))
			var imgUrl = "";
			imgOptions["imageSources"].forEach(function (element) {
				if (element["breakpoint"] == "original" || Helpers.resizeObject.windowWidth >= element["breakpoint"]) {

					imgUrl = element["imgUrl"]
				}
			})
			$this.attr("src", imgUrl);
		})
	}, 100);
	imgSrcHandler();
    /*
	 * Custom Missing images Replacer 
	 * ROC is hardcoded to use the SVGs in the ResourcePackages\Roc\assets\images\na-images\...
	 * I look for all na-*.svg strings in img src attributes and change them to our custom JPGs.
	 * This is not needed if you can simply copy in your custom SVGs.
	 * These custom images are too complex to recreate as SVGs so I opt for JPG.
	 * This code can be removed if ROC admin is updated to include specifying custom missing image files. 
	 */
	var missingImageNameArray = [
		"na-xxs.svg",
		"na-xs.svg",
		"na-s.svg",
		"na-m.svg",
		"na-l.svg",
		"na-xl.svg",
		"na-xxl.svg"
	]
	var customMissingImageReplacer = function () {
		$("img").each(function () {
			var imgSrc = $(this).attr("src");
			if (new RegExp(missingImageNameArray.join("|")).test(imgSrc)) {
				var newImgSrc = imgSrc.replace("svg", "jpg");
				$(this).attr("src", newImgSrc);
			}
		});
	}
	customMissingImageReplacer();

    /* 
    * slickActiveMatchHeights
    * Add slider components to match in here.
    */
	//    var sliderMatchHeights = function (slider) {
	//        var $slider = $(slider);
	//        var $sliderActiveSlides = $slider.find(".slick-list .slick-active");
	//        // Add specific slick instances first and use the bottom two as defaults 
	//        if ($slider.is("#safety-partners-slider")) {
	//            $slider.find(".safety-partner").matchHeights();
	//        } else if ($slider.hasClass("hawkSlider")) {
	//            // .hawkSlider specific matchHeights
	//            // Add the new matchHeights here
	//            $sliderActiveSlides.find(".media").matchHeights();
	//            $sliderActiveSlides.find(".itemTitle").matchHeights();
	//            $sliderActiveSlides.find(".itemDescription").matchHeights();
	//            $sliderActiveSlides.find(".itemPrice").matchHeights();
	//        } else if ($slider.hasClass("slider")) {
	//            // .slider specific matchHeights
	//            // Add the new matchHeights here
	//            $sliderActiveSlides.matchHeights();
	//        }
	//    }

	//    var sliderDebouncedMatchHeights = function (slider) {
	//        return Helpers.debounce(function () {
	//            sliderMatchHeights(slider)
	//        }, 100);
	//    };

    /*
     * On slider init call match heights and also add event listener for slick buttons to also match heights.
     * I do this since I only match heights of the .active slick elements.
     */
	//    $("#safety-partners-slider, .slider, .hawkSlider").on("init", function (event, slick) {
	//        sliderMatchHeights(event.currentTarget)
	////
	//        $(window).on("resize", sliderDebouncedMatchHeights(event.currentTarget));
	////
	////        // add events handlers to slick instances click
	//        $(event.currentTarget).find(".slick-prev, .slick-next").on("click", function () {
	//            sliderDebouncedMatchHeights(event.currentTarget);
	//        })
	//    });

	//-------------------------
	// Header
	//-------------------------

	// Move .accountNav into navigation for mobile View.
	// also changes the svg to the one approved in the designs.
	// This function is called after the template is rendered in siteHeader.js
	var accountNavPrepender = function () {
		var $accountNav = $(".accountNav");
		if (Helpers.resizeObject.windowWidth >= Helpers.constantsObject.screenMediumMin) {
			$(".accountNav svg use").get(0).setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-login');
			$accountNav.prependTo(".headerLinks.headerLogin");
		} else {
			$(".accountNav svg use").get(0).setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-login-no-circle');
			$accountNav.prependTo(".accountNav-wrapper");
		}
	};


	$(document).ready(function () {
		setTimeout(function () {
			$(".productListInner .itemWrapper").find(".itemImage").each(function () {
				if ($(this).hasClass("roc-image-na")) {
					$(this).parent().addClass("roc-image-link-na");
				}
			});
			$("#hawktoppager,#hawkbottompager,.gridViewAlt").addClass("list-visible");
			$(".railNav li:has(ul)").addClass("rail-nav-sub-on");
		}, 500);
		setTimeout(function () {
			$(".safety-partners, .recentlyViewedWrapper").addClass("visible");
		}, 400);
		setTimeout(function () {
			$('#safety-partners-slider').slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				responsive: [{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
				]
			});
		}, 500);

	});

	$(function () {	
		$(document).ready(function () {
			if($('.bannerContent.iframe-wrapper').length > 0) {
				$("#youTubeBtn").each(function() {
					$(this).on({
						click:function() {
							var videoURL = $(this).closest('.iframe-wrapper').find('iframe').prop('src');
							var videoURLplay = videoURL += "?autoplay=1";							
							$(this).closest('.iframe-wrapper').find('iframe').prop('src',videoURLplay);
							$(this).closest('.iframe-wrapper').addClass('yt-thumb-hidden');
						}
					});
				});	
			}
		});
	});

	//-------------------------
	// Footer
	//-------------------------
	var footerNavSpanTitleMatchHeights = function () {
		other$(".footer .navSpan .title").matchHeights();
	}
	footerNavSpanTitleMatchHeights();


	// Pushing functions to corresponding event Arrays
	Helpers.resizeFunctionsArray.push(imgSrcHandler);
	Helpers.resizeFunctionsArray.push(accountNavPrepender);
	Helpers.resizeFunctionsArray.push(footerNavSpanTitleMatchHeights);

	var SetupGlobals = {
		accountNavPrepender: accountNavPrepender
	};


	$(document).ajaxComplete(function (event, request, settings) {
		setTimeout(function () {
			equalheight('.itemWrapper .productBrand');
			equalheight('#hawkitemlist .itemWrapper .itemTitle');
			equalheight('#hawkitemlist .itemWrapper .itemSku');
			equalheight('#hawkitemlist .itemWrapper .itemContent .itemAction');
		}, 500);

		setTimeout(function () {
			$(".productListInner .itemWrapper").each(function () {
				$(this).find(".hawk-brokenImage").attr("src", "/ResourcePackages/Roc/assets/images/na-images/na-m.jpg");
			});
		}, 1000);

	});

	$(window).load(function () {
		equalheight('.itemWrapper .productBrand');
		equalheight('#hawkitemlist .itemWrapper .itemTitle');
		equalheight('#hawkitemlist .itemWrapper .itemSku');
		equalheight('#hawkitemlist .itemWrapper .itemContent .itemAction');
	});


	function ItemsHeightInit() {
		/** equalheight Apply to itemWrapper not on  Slick itemWrapper */
		if ($('.itemWrapper:not(.slick-slide)').length) {
			equalheight('.itemWrapper:not(.slick-slide) .itemImageWrapper');
			equalheight('.itemWrapper:not(.slick-slide) .productBrand');
			equalheight('.itemWrapper:not(.slick-slide) .itemTitle');
		}

		/** This dead code will remove once Ticket #453508 is Tested */
		// if($('.rocModule-miniList').length){
		// 	equalheight('.rocModule-miniList .itemWrapper .media');
		// 	equalheight('.rocModule-miniList .itemWrapper .itemContent');
		// 	equalheight('.rocModule-miniList .itemWrapper .itemAction');
		// }

		// if($('.hawkSlider').length){
		// 	equalheight('.hawkSlider .itemWrapper .media');
		// 	equalheight('.hawkSlider .itemWrapper .itemTitle');
		// 	equalheight('.hawkSlider .itemWrapper .itemDescription');
		// 	equalheight('.hawkSlider .itemWrapper .itemAction');
		// }

		equalheight('.productListInner .itemWrapper:not(.slick-slide) .itemContent');
		equalheight('.productList .categoryHeading .categoryTitle');
	};

	function itemHeight(resize) {
		if (resize) {
			new ItemsHeightInit();
		} else {
			setTimeout(function () {
				new ItemsHeightInit();
			}, 500);
		}
	};

	function altViewImages() {
		var $lisAlt = $('.productDetails ul.altViews li');
		if ($lisAlt.length) {
			if ($lisAlt.length > 2) {
				$lisAlt.parent().removeClass("alt-view-hidden");
			};	
		}	
	};	

	function altViewEnlargeImages() {
		var $lisEnlargeAlt = $('.enlarge-view-modal ul.altViews li');
		if ($lisEnlargeAlt.length) {
			if ($lisEnlargeAlt.length > 2) {
				$lisEnlargeAlt.parent().removeClass("alt-view-hidden");
			};	
		}	
	};	
	
	function pdpVideoIn() {	
		setTimeout(function () {
			var $pdpVideo = $('#product-accordion .panel-default .panel-body .emptyTab:contains(There are no videos for this product)');
			if ($pdpVideo.length) {
				$pdpVideo.closest(".panel.panel-default").addClass("view-panel-hidden");	
			}
			var $pdpVideoNot = $("#product-accordion .panel-default .panel-body .productVideoTabWrapper").not(":has(.emptyTab)");
			if ($pdpVideoNot.length) {
				$pdpVideoNot.closest(".custom-tabs").find(".panel-video").removeClass("view-panel-hidden");
			}					
		}, 1000);		
	};		
	
    function initializeProductTabs() {
		var productTabs = $('#product-accordion');
		if (productTabs.length) {
//			$("#product-accordion .panel:not(.view-panel-hidden)").find(".panel-heading").each(function () {
//				$(this).contents().clone().appendTo("#product-accordion-tabs");
//			});
//			$("#product-accordion-tabs").find(".panel-title").each(function () {
//				$(this).wrap('<li/>');
//			});
			$("#product-accordion-tabs li:first").find("a").addClass("tab-active");
			$("#product-accordion-tabs li a").each(function () {
				$(this).on('click', function () {
					$("#product-accordion-tabs li a").removeClass("tab-active");
					$(this).addClass("tab-active");
					var productAccordionTabs = $("#product-accordion .panel a[aria-expanded='true']");
					var productAccordionTabsActive = $("#product-accordion .panel.panel-open");
					productAccordionTabs.parent().parent().parent().addClass('panel-open');
					if (productAccordionTabs.parent().parent().parent().hasClass('panel-open')) {
						productAccordionTabsActive.removeClass('panel-open');
					}
					else {
						$('#product-accordion .panel.panel-open').removeClass('panel-open');
						productAccordionTabs.parent().parent().parent().addClass('panel-open');
					}
					$("#product-accordion .panel").not(".panel-open").find(".panel-title a").attr({ 'class': 'collapsed', 'aria-expanded': 'false' });
					$("#product-accordion .panel").not(".panel-open").find(".panel-collapse").attr({ 'class': 'panel-collapse collapse', 'aria-expanded': 'false' });
				});
			});
		}				
    }
	
	$(document).ready(function() {	
		$('.icon-zoom-in').click(function(e) {
			if ($(e.target).attr('aria-pressed') == 'false') {
				$(e.target).attr('aria-pressed','true');
				$('.icon-zoom-out').attr('aria-pressed','false');
			} 
		});

		$('.icon-zoom-out').click(function(e) {
			if ($(e.target).attr('aria-pressed') == 'false') {
				$(e.target).attr('aria-pressed','true');
				$('.icon-zoom-in').attr('aria-pressed','false');
			} 
		});
	});	

	function triggerFocus(element) {
        var eventType = "onfocusin" in element ? "focusin" : "focus",
            bubbles = "onfocusin" in element,
            event;
    
        if ("createEvent" in document) {
            event = document.createEvent("Event");
            event.initEvent(eventType, bubbles, true);
        }
        else if ("Event" in window) {
            event = new Event(eventType, { bubbles: bubbles, cancelable: true });
        }
        element.focus();
        try {
            element.dispatchEvent(event);
        }catch(err) {}
    }

	function pdpEnlargeFocus() {
        $('#enlarge-view-button-pdp-img').click(function(){
           
            
            setTimeout(function() {
                if($('#enlarge-view-modal').length > 0) {
                    $('.skip-to-main').eq(0).replaceWith('<p class="skip-to-main" tabindex="0">Modal closed</p>');
                    $('#enlarge-view-modal .mfp-close').off('click');
                    $('#enlarge-view-modal .mfp-close').click(function(){
                        setTimeout(function() {
                        triggerFocus($('#enlarge-view-button-pdp-img'));
                        $('.skip-to-main').eq(0).replaceWith('<a href="#main-nav-bar" class="skip-to-main">Skip to Main Content</a>');
                    }, 100);
                      });
                }
              }, 1000);
             
            
          });
    }

    $( document ).ready(function() {
        setTimeout(function() {
            pdpEnlargeFocus();
          }, 2000);
        
    });
	
	
	$(window).load(function () {
		itemHeight();
		//setTimeout(function () {
			
		//}, 1500);			
	});

//	$(document).ready(function() {
//		$(".selections .formee .formee-control-inline").change(function() {
//			setTimeout(function () {
//				initializeProductTabs();
//			}, 500);	
//		});			
//	});	

	$(window).resize(function () {
		itemHeight(true);
	});

	/** This dead code will remove once Ticket #453508 is Tested */
	$(document).ajaxComplete(function () {
		// itemHeight();
		altViewImages();
		altViewEnlargeImages();
		pdpVideoIn();
		initializeProductTabs();
	});

	return SetupGlobals;

});

